module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=VA - Vatican City.1f48f155.svg";